import type React from "react";
import styles from "./style.module.less";
interface NothingToSeeHereProps {
    content: string;
}
export const NothingToSeeHere: React.FC<NothingToSeeHereProps> = ({ content }) => {
    return <p className={styles.content}>{content}</p>;
};
NothingToSeeHere.displayName = "NothingToSeeHere"
